import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {feedInstitionFromApi} from 'web-app/react/feed/feed-switcher/reducer';

import Recipient from '../react/entities/recipients/model';

export default class PostApi {
    static getFeedInstitutions() {
        return RESTClient.getAuthenticatedObservable('v2/feed/institutions').map(response =>
            List(response.institutions).map(feedInstitionFromApi),
        );
    }

    static getPossibleRecipients(data) {
        return RESTClient.getAuthenticatedObservable('v2/posts/to', data).map(result => result.to);
    }

    static getPossibleSenders(context) {
        return RESTClient.getAuthenticatedObservable('v2/posts/from', {
            context,
            filterByContext: false,
        }).map(senders => {
            return List(
                senders.from.map(from =>
                    Recipient.fromAPI({
                        ...from.recipient,
                        isDefault: from.default,
                    }),
                ),
            );
        });
    }

    static likeImage(imageId) {
        return RESTClient.postAuthenticatedObservable('feed/feed/likeimage', {
            imageId,
        });
    }

    static unlikeImage(imageId) {
        return RESTClient.postAuthenticatedObservable('feed/feed/unlikeimage', {
            imageId,
        });
    }

    static tagImage(imageId, childId, siteId) {
        return RESTClient.postAuthenticatedObservable('feed/image/tagchild', {
            imageId,
            childId,
            siteId,
        });
    }

    static removeImageTag(imageId, childId) {
        return RESTClient.postAuthenticatedObservable('feed/image/removetaggedchild', {
            imageId,
            childId,
        });
    }
}
